import { useEffect, useState } from "react";

import {
  rowsForBrowserInfoSkeleton,
  stylesForBrowserInfoSkeleton,
} from "../../../../../utils/constants";

import useBrowserInfo from "../../../../../hooks/useBrowserInfo";

import { TableRow } from "./components/TableRow/TableRow";
import TableSkeleton from "./components/TableSkeleton";

import { Wrapper } from "./BrowserInfoTable.styled";

export const BrowserInfoTable = () => {
  const [loading, setLoading] = useState(true);

  const browserData = useBrowserInfo();

  useEffect(() => {
    if (browserData.length > 0) {
      setLoading(false);
    }
  }, [browserData]);

  return (
    <Wrapper>
      {rowsForBrowserInfoSkeleton.map((row, idx) => (
        <TableRow
          key={idx}
          label={row}
          value={
            loading ? (
              <TableSkeleton rowStyles={stylesForBrowserInfoSkeleton[idx]} />
            ) : (
              browserData?.[idx]?.value
            )
          }
        />
      ))}
    </Wrapper>
  );
};
